module.exports = __webpack_public_path__ + "assets/img/flow.2d792b8f.png";